import createAsyncAction from 'utilities/create-async-action';

/**
 * Create the action
 */

import retrieveAuthenticatedUser from 'actions/authentication/retrieve';

const { 
    thunk, 
    request, 
    success, 
    error 
} = createAsyncAction({
    name: 'removeFavorite',
    asyncAction: removeFavorite
});

function removeFavorite(id, fetch, dispatch) {
    return fetch.post(`/favorites/remove/${id}`)
            .then(async (response) => {
                dispatch(success(response.data));
                dispatch(retrieveAuthenticatedUser());
            })
            .catch(err => {
                dispatch(error(err));
            });
}

/**
 * Export the components
 */

export default thunk;
export { request, success, error };
